import { Editor } from "@tiptap/react";
import { inlineFragment } from "@css-inline/css-inline-wasm";

export const getEditorHtml = (editor: Editor | null, emptyToNullConversion: boolean = false) => {
  if (!editor || (emptyToNullConversion && editor.isEmpty)) {
    return null;
  }

  /**
   * Sets inline styles to tiptap output, because on some extension e.g. table it is not possible to set styles on child nodes.
   * If you set any styles here make sure to also copy them to backoffice-client/src/components/LbEditor/LegalbirdTipTapEditor.css
   */
  return inlineFragment(
    editor.getHTML(),
    `
        .no-borders td {
          border: none;
        }

        .bottom-borders td {
          border: none;
          border-bottom: 1px solid #ccc;
        }

        .bottom-borders tr:last-of-type td {
           border-bottom: none;
        }

        table {
          border-collapse: collapse;
          margin: 0;
          overflow: hidden;
          table-layout: fixed;
          width: 100%;
        }

        table td {
          border: 1px solid #ccc;
          padding: 0 12px;
          box-sizing: border-box;
          min-width: 1em;
          position: relative;
          vertical-align: top;
        }

        p {
            min-height: 16px;
        }
    `,
  );
};

export const setEditorContent = (editor: Editor | null, content: string) => {
  if (!editor) {
    console.log("editor missing");
    return;
  }
  editor?.commands.setContent(content);
  editor?.commands.focus("start");
};
